export const getDaysSinceUsage = (lastUsageDate: string): number => {
  const usageDate = new Date(lastUsageDate);
  const now = new Date();
  const diffTime = Math.abs(now.getTime() - usageDate.getTime());
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
  return diffDays;
};

export const getUsageColor = (daysAgo: number): string => {
  if (daysAgo > 365) return "error.main";
  if (daysAgo > 180) return "warning.main";
  return "text.primary";
};

export const getObjectTypeColor = (
  objectType: string,
):
  | "default"
  | "primary"
  | "secondary"
  | "error"
  | "warning"
  | "info"
  | "success" => {
  const type = objectType.toLowerCase();
  if (type.includes("table")) return "error";
  if (type.includes("view")) return "warning";
  if (type.includes("procedure") || type.includes("function")) return "info";
  return "default";
};
